import React from 'react';
import Wrapper from '../Wrapper';
import FeatureCourses from './FeatureCourses.jsx';

function FeatureCoursesWrapper(props) {
  return (
    <Wrapper>
      <FeatureCourses {...props} />
    </Wrapper>
  );
}

export default FeatureCoursesWrapper;
